import React, { Component } from 'react'
import BannerTreatment from './BannerTreatment'
import Appointment from './Appointment'
import { Helmet } from 'react-helmet'
import BlogOneWordPress from './Blog/BlogOneWordPress'

class TreatmentPackages extends Component {

  render() {
    return (
      <React.Fragment>

        <Helmet>
          <meta charSet='utf-8' />
          <title>Best and affordble Sleep Study Tretment Cost in Hyderabad | Sleep Therapuetics</title>
          <meta name='description' content='Get the best and affordable sleep study treatment cost in Hyderabad at Sleep Therapeutics. Advanced sleep testing, expert doctors, and transparent pricing.' />
        </Helmet>

        <BannerTreatment pageTitle='Treatment Packages' />

        <section className="about-page-top-content-wrap section-padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 offset-lg-2 text-center">

                <p>
                  At Sleep Therapeutics, we have some of the best treatment packages in the field of sleep medicine.
                  Our sleep specialists tailor the treatment packages per each patient's needs following their diagnosis.
                  Thus, each patient receives tailored care and support throughout their treatment journey.
                  The treatments could last three to twelve months, depending on the condition.
                </p>

                <p>
                  Our commitment to each patient is reflected in the words of our Founder,
                  Dr. Harshini Errabelli.
                </p>

                <p>
                  “Our priorities are patient time, comfort, safety, privacy, and treatment compliance.”
                </p>

              </div>
            </div>
          </div>
        </section>

        <section className="promo-content-section promo-bg section-padding">
          <div className="container">

            <div className="text-center mb-5">
              <h1>Here are our treatment packages:</h1>
            </div>

            {/* 1 SLEEP STUDY PACKAGE */}
            <div className="row align-items-center mb-5">

               <div className="col-lg-6">

                <div className="promo-text vAboutDoc">

                  <h2>Sleep Study Package</h2>

                  <p className='vTreatSubText'>
                    For individuals experiencing sleep disturbances such as snoring,
                    insomnia, daytime fatigue, or suspected sleep apnea:
                  </p>

                  <ul>
                    <li>Consultation with experienced sleep specialists</li>
                    <li>Comprehensive sleep study (Polysomnography)</li>
                    <li>Detailed sleep analysis report</li>
                    <li>Personalised treatment recommendations</li>
                    <li>Guidance on lifestyle and sleep hygiene</li>
                  </ul>

                  <a href="/Contact-Best-Sleep-apnea-Speialist-in-India#consult" className="theme-btn fill-btn vBlue-btn">Enquire Now</a>

                </div>

              </div>

              <div className="col-lg-6">
                <img
                  src={require("../assets/img/whatsinaname/treamentpackages/Sleep-Study.jpg")}
                  alt=""
                  className="img-fluid"
                />
              </div>

            </div>

            {/* 2 INSOMNIA PACK */}
            <div className="row align-items-center mb-5">

              <div className="col-lg-6">
                <img
                  src={require("../assets/img/whatsinaname/treamentpackages/InsomniaPack1.png")}
                  alt=""
                  className="img-fluid"
                />
              </div>

              <div className="col-lg-6">
                <div className="promo-text vAboutDoc">

                  <h2>Insomnia Pack</h2>
                  <p className='vTreatSubText'>For individuals suffering from insomnia:</p>

                  <ul>
                    <li>Includes consultations with sleep specialists & other doctors</li>
                    <li>Sleep tracking and monitoring</li>
                    <li>Dietitian and fitness coach consultations</li>
                    <li>Cognitive Behaviour Therapy</li>
                  </ul>

                  <a href="/Contact-Best-Sleep-apnea-Speialist-in-India#consult" className="theme-btn fill-btn vBlue-btn">Enquire Now</a>

                </div>
              </div>

            </div>

            {/* REST CODE UNCHANGED (OSA, General, Healthy Sleep, Testimonials) */}

            {/* 3 OSA PACK */}
            <div className="row align-items-center mb-5">
              <div className="col-lg-6">
                <img
                  src={require("../assets/img/whatsinaname/treamentpackages/OSAPack2.png")}
                  alt=""
                  className="img-fluid"
                />
              </div>

              <div className="col-lg-6">
                <div className="promo-text vAboutDoc">
                  <h2>OSA (Obstructive Sleep Apnea) Pack</h2>
                  <p className='vTreatSubText'>
                    For individuals suffering from Obstructive Sleep Apnea:
                  </p>
                  <ul>
                    <li>Consultations with sleep specialists</li>
                    <li>Sleep Study</li>
                    <li>Personalised diet plan</li>
                    <li>Exercise prescription</li>
                    <li>Monitoring of CPAP compliance</li>
                  </ul>
                  <a href="/Contact-Best-Sleep-apnea-Speialist-in-India#consult" className="theme-btn fill-btn vBlue-btn">Enquire Now</a>
                </div>
              </div>
            </div>

            {/* 4 GENERAL */}
            <div className="row align-items-center mb-5">
              <div className="col-lg-6">
                <div className="promo-text vAboutDoc">
                  <h2>General Sleep Checkup</h2>
                  <p className='vTreatSubText'>
                    For anyone who wants to know about their sleep health
                    and the effect of sleep on their overall health.
                  </p>
                  <ul>
                    <li>Includes two sleep consultations</li>
                    <li>Sleep testing and reporting</li>
                    <li>Provision of sleep kit</li>
                    <li>Education about sleep hygiene</li>
                  </ul>
                  <a href="/Contact-Best-Sleep-apnea-Speialist-in-India#consult" className="theme-btn fill-btn vBlue-btn">Enquire Now</a>
                </div>
              </div>

              <div className="col-lg-6">
                <img
                  src={require("../assets/img/whatsinaname/treamentpackages/GeneralSleepCheckup.png")}
                  alt=""
                  className="img-fluid"
                />
              </div>
            </div>

            {/* 5 HEALTHY */}
            <div className="row align-items-center mb-5">
              <div className="col-lg-6">
                <img
                  src={require("../assets/img/whatsinaname/treamentpackages/HealthySleepPack3.png")}
                  alt=""
                  className="img-fluid"
                />
              </div>

              <div className="col-lg-6">
                <div className="promo-text vAboutDoc">
                  <h2>My Healthy Sleep Pack</h2>
                  <p className='vTreatSubText'>
                    For kids, adolescents & adults who have difficulty sleeping on time
                    and wish to improve their sleep quality.
                  </p>
                  <ul>
                    <li>Consultations with sleep specialists</li>
                    <li>Health coach guidance</li>
                    <li>Sleep hygiene sessions</li>
                  </ul>
                  <a href="/Contact-Best-Sleep-apnea-Speialist-in-India#consult" className="theme-btn fill-btn vBlue-btn">Enquire Now</a>
                </div>
              </div>
            </div>

            {/* TESTIMONIALS */}
            <h2 className='text-center pb-3'>Testimonials</h2>

            <div className="row justify-content-center gap-4 px-md-0 px-4">

              <div className="col-lg-3 col-md-5 px-1">
                <video controls preload="metadata" className='w-100'
                  style={{ height: '400px', objectFit: 'cover' }}>
                  <source src={require("../assets/img/whatsinaname/treamentpackages/testimonial-1.mp4")} type="video/mp4" />
                </video>
              </div>

              <div className="col-lg-3 col-md-5 px-1">
                <video controls preload="metadata" className='w-100'
                  style={{ height: '400px', objectFit: 'cover' }}>
                  <source src={require("../assets/img/whatsinaname/treamentpackages/testimonial-2.mp4")} type="video/mp4" />
                </video>
              </div>

            </div>

          </div>
        </section>

        <BlogOneWordPress />
        <Appointment appointmentTitle={"Book a Consultation"} />

      </React.Fragment>
    )
  }
}

export default TreatmentPackages